import { deleteThreadFromSidebarEvent } from '#pplx/frontend/apps/ask/events/thread/analytics.js';
import { useThreadMutations } from '#pplx/frontend/apps/ask/hooks/threads-hooks/useThreadMutations.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback } from 'react';
export function useSpaceThreadDeletionAction() {
    const { track } = useInstrumentation();
    const { deleteThread } = useThreadMutations({ reason: 'sidebar-promoted-space-thread' });
    return useCallback(({ thread, href, spaceSlug, onDeleted }) => {
        if (!thread.uuid)
            return;
        track(deleteThreadFromSidebarEvent({
            name: 'delete thread from sidebar',
            data: { entryUUID: thread.uuid },
        }));
        deleteThread({
            entryUUID: thread.uuid,
            collectionSlug: spaceSlug,
            callback: () => onDeleted(href),
        });
    }, [deleteThread, track]);
}
export function useSpaceThreadDeletion({ spaceSlug, onDeleted, }) {
    const deleteThread = useSpaceThreadDeletionAction();
    return useCallback((thread, href) => deleteThread({ thread, href, spaceSlug, onDeleted }), [deleteThread, onDeleted, spaceSlug]);
}
//# sourceMappingURL=useSpaceThreadDeletion.js.map